module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5XACn"))).then(() => parcelRequire('fY0qZ'));